import type { TransactionEvent } from "@developerz.ai/ggcoin-sdk";
import { Show } from "solid-js";
import { formatTime } from "../lib/time.ts";
import { Money } from "./Money.tsx";

/**
 * Single row in the transactions feed. Shared by the Dashboard's preview and
 * the History page so the two surfaces stay in sync as the event shape evolves.
 */
export function TransactionFeedRow(props: { event: TransactionEvent }) {
  const isPosted = () => props.event.type === "transaction.posted";
  const id = () =>
    props.event.type === "transaction.posted"
      ? props.event.transactionId
      : props.event.originalTransactionId;
  return (
    <li class="feed-row">
      <span class="feed-kind">
        <Show when={isPosted()} fallback={"reversal"}>
          {props.event.type === "transaction.posted" ? props.event.kind : ""}
        </Show>
      </span>
      <span class="feed-id">{id()}</span>
      <span>
        <Money amount={props.event.amount} />{" "}
        <span class="muted" style={{ "font-size": "0.8rem" }}>
          {formatTime(props.event.postedAt)}
        </span>
      </span>
    </li>
  );
}

/** Stable key for a feed event. */
export function transactionFeedKey(event: TransactionEvent): string {
  return event.type === "transaction.posted"
    ? `posted:${event.transactionId}`
    : `reversed:${event.reversalTransactionId}`;
}
